function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-58 -97)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "plain-dot-grid_svg__a",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(58 97)"
}), /*#__PURE__*/React.createElement("path", {
  className: "plain-dot-grid_svg__b",
  d: "M72.5 97a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "plain-dot-grid_svg__a",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(80 97)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "plain-dot-grid_svg__c",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(58 108)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "plain-dot-grid_svg__d",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(69 108)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "plain-dot-grid_svg__e",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(80 108)"
}), /*#__PURE__*/React.createElement("path", {
  className: "plain-dot-grid_svg__f",
  d: "M61.5 119a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "plain-dot-grid_svg__e",
  d: "M72.5 119a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "plain-dot-grid_svg__a",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(80 119)"
}));

function SvgPlainDotGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgPlainDotGrid;